import Vue from 'vue'

class PublicApiTokenRepository {

  controller = null

  search(data) {
    if (this.controller) {
      this.controller.abort()
    }
    this.controller = new AbortController()

    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/security/public-api-access-token/search',
        method: 'post',
        data,
        signal: this.controller.signal,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/security/public-api-access-token/' + id,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  create(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/security/public-api-access-token',
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  update(id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/security/public-api-access-token/' + id,
        method: 'put',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  delete(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/security/public-api-access-token/' + id,
        method: 'delete',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  regenerate(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/security/public-api-access-token/' + id + '/regenerate',
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default new PublicApiTokenRepository()
